import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_GALLERIES } from '@/api/endpoints';
import { GALLERY_QUERY_KEY } from '@/api/queryKeys';
import type { GalleryResponse } from '@/types/gallery';
import { unwrapAxiosResponse } from '@/utils/axios';
import { joinPath } from '@/utils/global';

export const useGallery = (galleryId: string | undefined) =>
  useQuery<GalleryResponse>({
    queryKey: [...GALLERY_QUERY_KEY, galleryId],
    queryFn: () =>
      apiClient
        .get<GalleryResponse>(joinPath(API_GALLERIES, galleryId!))
        .then(unwrapAxiosResponse),
    enabled: !!galleryId,
  });
